<template>
  <div class="home">
    <header-com></header-com>
    <div class="content">
      <div :class="['player', leftShow && 'left-show', rightShow && 'right-show']">
        <div class="mask" @click="closeMusicList"></div>
        <player></player>
      </div>
      <music-list @setStatus="setStatus" ref="music-all" :type="0"></music-list>
      <music-list @setStatus="setStatus" ref="music-selected" :type="1"></music-list>
    </div>
  </div>
</template>

<script>
import HeaderCom from '../../components/header'
import MusicList from './components/music-list'
import Player from './components/player'
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      leftShow: true,
      rightShow: true
    }
  },
  components: {
    HeaderCom,
    MusicList,
    Player
  },
  created () {
    this.getAllMusicList()
  },
  methods: {
    ...mapActions(['getAllMusicList']),
    setStatus ({ type, bool }) {
      if (type === 0) {
        this.leftShow = !bool
      } else {
        this.rightShow = !bool
      }
    },
    closeMusicList () {
      this.$refs['music-all'].isClose = true
      this.$refs['music-selected'].isClose = true
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  height: 100vh;
  overflow: hidden;
  .content {
    position: relative;
    height: calc(100vh - 60px);
    display: flex;
    justify-content: space-between;
    .mask {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(88, 96, 109, 0.9);
    }
    .player {
      position: absolute;
      width: 100%;
      height: 100%;
      background: url('https://open.saintic.com/api/bingPic/') no-repeat;
      background-size: cover;
      transition: transform 0.35s ease-out;
      &.left-show {
        transform: translate(320px, 0);
      }
      &.right-show {
        transform: translate(-320px, 0);
      }
      &.left-show.right-show {
        transform: translate(0);
      }
    }
  }
}
</style>
